import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Spacer, spacerAlignItems } from '@amzn/dvui/dist/Spacer'
import { TvodButtonScope, TvodButton } from './tvodButton'
import { SvodButton } from './svodButton'
import { MoreSubscriptionOptionsButton } from './moreSubscriptionOptionsButton'
import { isEmpty } from '../../utils/utils'
import {
  getSvodWinnersChildren,
  getTvodWinnersChildren
} from '../../selectors/acquisitionActions'
import * as utilityClasses from '../utilityClasses.module.scss'
import { isSubscribeActionTreeRight } from '../../utils/getAcquisitionActionChildren';
import { AtfTreatment, AtfTreatmentProps } from '../../reducers/features'

const TreeBehaviour = {
  COLLAPSED: 'Collapsed',
  EXPANDED: 'Expanded'
}

type IGetSvodButtons = {
  forceDoubleHeight: boolean,
  titleId?: string,
  svodWinners?: WpsRuntime.atv.wps.SubscribeActionTreeModelProps
}
const getSvodButtons = ({
  forceDoubleHeight,
  titleId,
  svodWinners,
}: IGetSvodButtons, atfTreatment: AtfTreatment) => {
  if (!svodWinners) {
    return []
  }
  const behaviour = svodWinners.metadata && svodWinners.metadata.behaviour

  switch (behaviour) {
    case TreeBehaviour.COLLAPSED:
      return !isSubscribeActionTreeRight(svodWinners) ? [] : [
        <MoreSubscriptionOptionsButton
          key={'MsoButton'}
          svodWinners={svodWinners}
          titleId={titleId}
          forceDoubleHeight={forceDoubleHeight}
          atfTreatment={atfTreatment}
        />
      ]
    case TreeBehaviour.EXPANDED:
      const svodButtons = getSvodWinnersChildren(svodWinners)
      return svodButtons
        .filter(action => isEmpty(action.problems))
        .map((action, idx) => (
          <SvodButton
            key={`SvodButton-${idx}`}
            svodAction={action}
            forceDoubleHeight={forceDoubleHeight}
            atfTreatment={atfTreatment}
          />
        ))
    default:
      return []
  }
}

type IGetTvodButtons = {
  tvodButtonScope: TvodButtonScope
  tvodWinners?: WpsRuntime.atv.wps.PurchaseActionTreeModel
}
const getTvodButtons = ({
  tvodWinners,
  tvodButtonScope,
}: IGetTvodButtons, atfTreatment: AtfTreatment) => {
  const tvodWinnersChildren = getTvodWinnersChildren(tvodWinners)
  return tvodWinnersChildren.map(
    (action: WpsRuntime.atv.wps.PurchaseActionProps, idx: number) => (
      <TvodButton
        key={`TvodButton-${idx}`}
        tvodAction={action}
        scope={tvodButtonScope}
        atfTreatment={atfTreatment}
      />
    )
  )
}

export interface IAcquisitionType extends AtfTreatmentProps {
  acquisitionActions?: WpsRuntime.atv.wps.AcquisitionActionsModelProps
  titleId?: string
  tvodButtonScope: TvodButtonScope
  forceDoubleHeight: boolean
}

export const Acquisition = ({
  acquisitionActions,
  titleId,
  tvodButtonScope,
  forceDoubleHeight,
  atfTreatment
}: IAcquisitionType) => {
  if (!acquisitionActions) {
    return null
  }

  const { tvodWinners, svodWinners } = acquisitionActions

  const svodButtons = getSvodButtons({ forceDoubleHeight, titleId, svodWinners }, atfTreatment)
  const tvodButtons = getTvodButtons({ tvodWinners, tvodButtonScope }, atfTreatment)

  const allButtons = [...svodButtons, ...tvodButtons].filter(Boolean)

  return isEmpty(allButtons) ? null : (
    <Spacer className={utilityClasses.fullWidthPhablet} alignItems={spacerAlignItems.top}>
      {allButtons}
    </Spacer>
  )
}
